import * as query from './reducers/query';
import * as run from './reducers/run';
import * as email from './reducers/email';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    REPORTS_QUERY_REQUEST: query.request,
    REPORTS_QUERY_FINISH: query.finish,
    REPORTS_QUERY_ERROR: query.error,
    REPORTS_QUERY_CLEAR: query.clear,

    REPORTS_RUN_REQUEST: run.request,
    REPORTS_RUN_FINISH: run.finish,
    REPORTS_RUN_ERROR: run.error,
    REPORTS_RUN_CLEAR: run.clear,

    REPORTS_EMAIL_REQUEST: email.request,
    REPORTS_EMAIL_FINISH: email.finish,
    REPORTS_EMAIL_ERROR: email.error,
    REPORTS_EMAIL_CLEAR: email.clear,
});
